export default __webpack_public_path__ + "static/media/GeraldKitchen400.90805402.jpg";